import { boot } from 'quasar/wrappers';

import { H } from 'highlight.run';

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async (/* { app, router, ... } */) => {
  if (process.env.VITE_ENV === 'prod-highlight') {
    H.init('2d1rpnlg', {
      environment: 'production',
      version: '1.0',
      tracingOrigins: ['127.0.0.1:8000'],
      networkRecording: {
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [
          // insert full or partial urls that you don't want to record here
          // Out of the box, Highlight will not record these URLs (they can be safely removed):
          'https://www.googleapis.com/identitytoolkit',
          'https://securetoken.googleapis.com',
        ],
      },
    });
  }
});
